<template>
  <div class="Bind">
    <Header></Header>
    <div class="Content" :style="{minHeight:minheight + 'px'}">
      <div class="bindphone" v-if="success_status">
        <p class="title center">账号绑定</p>
        <p class="tips">将当前的登录方式绑定到已有账号,完成绑定后下次可快速登录</p>
        <el-form
          :model="ruleForm2"
          :rules="rules2"
          ref="ruleForm2"
          label-width="90px"
          class="demo-ruleForm"
          label-position="left"
        >
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="ruleForm2.mobile" placeholder="请输入手机号码" style="width:310px;"></el-input>
          </el-form-item>
          <el-form-item label="图形码" prop="imgCode">
            <el-input v-model="ruleForm2.imgCode" placeholder="请输入图形码" class="img_code_input"></el-input>
            <img :src="imgCode" @click="Refresh" class="img_code_img" />
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-input v-model="ruleForm2.code" placeholder="请输入验证码" class="img_code_input"></el-input>
            <el-button
              type="primary"
              @click="getSmsCode"
              v-if="codestatus"
              style="margin-left:19px;"
            >获取验证码</el-button>
            <el-button type="info" plain disabled v-if="!codestatus">{{time}}s后重新获取</el-button>
          </el-form-item>
          <div class="sub-btn" @click="submitForm('ruleForm2')">确认</div>
        </el-form>
      </div>
      <div class="bindsuccess" v-if="!success_status">
        <!-- <img src="../../assets/home/Bind_success.png" /> -->
        <p class="succes_title">绑定成功！</p>
        <p class="success_login">当前的登录方式已绑定到已有账号，可快速</p>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import { getSmsCode } from "@/request/api";
import { wxbindMobile } from "@/request/api";
import { loginInOut3 } from "@/request/api";
import Cookies from "js-cookie";

// 引入手机号的验证处理请求
// import { validMobile } from "@/request/api";

export default {
  components: {
    Header,
    Footer
  },
  data() {
    // 表单验证
    var checkimg = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入图形验证吗"));
      } else {
        callback();
      }
    };
    // 短信登录
    var mobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确手机号"));
        }
      }
    };
    var code = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入短信验证码"));
      } else {
        callback();
      }
    };
    return {
      minheight: this.Common.minheight,
      codeurl: this.Common.codeurl,
      href: this.Common.href,
      imgCode: this.Common.codeurl,
      codestatus: true,
      success_status: true,
      time: 60,
      unionId: "",
      ruleForm2: {
        mobile: "",
        code: "",
        imgCode: ""
      },
      rules2: {
        mobile: [{ validator: mobile, trigger: "blur" }],
        code: [{ validator: code, trigger: "blur" }],
        imgCode: [{ validator: checkimg, trigger: "blur" }]
      },
      mobileNumRecord: false
    };
  },
  methods: {
    // 验证手机号的请求处理
    // validMobile: async function() {
    //   try {
    //     if (
    //       this.ruleForm2.mobile &&
    //       /^[1][3,4,5,7,8,9][0-9]{9}$/.test(this.ruleForm2.mobile)
    //     ) {
    //       this.validMobileData = await validMobile(this.ruleForm2.mobile);
    //       console.log("测试绑定的手机号的处理", this.validMobileData);
    //       if (this.validMobileData.data.code == "000000") {
    //         this.mobileNumRecord = true;
    //         this.$message({
    //           message: "当前手机号可用",
    //           type: "success"
    //         });
    //       } else {
    //         this.mobileNumRecord = false;
    //         this.$message.error(this.validMobileData.data.message);
    //       }
    //     } else {
    //       this.mobileNumRecord = false;
    //       this.$message.error("请输入正确的手机号码");
    //     }
    //   } catch (err) {
    //     this.mobileNumRecord = false;
    //     this.$message.error("手机号码验证请求错误，请稍后重试！");
    //   }
    // },

    Refresh() {
      let num = Math.ceil(Math.random() * 10);
      this.imgCode = this.codeurl + "?" + num;
    },
    // 发送短信验证码
    getSmsCode() {
      this.Refresh();
      if (this.ruleForm2.mobile === "" || this.ruleForm2.imgCode === "") {
        this.$refs["ruleForm2"].validateField("mobile");
        this.$refs["ruleForm2"].validateField("imgCode");
      } else {
        let data = {
          mobile: this.ruleForm2.mobile,
          imgCode: this.ruleForm2.imgCode,
          codeType: 2
        };
        getSmsCode(data)
          .then(res => {
            if (res.data.code == "00000") {
              // 倒计时
              this.codestatus = false; //点击button改变v-show的状态
              this.auth_timer = setInterval(() => {
                //定时器设置每秒递减
                this.time--; //递减时间
                if (this.time <= 0) {
                  this.codestatus = true; //60s时间结束还原v-show状态并清除定时器
                  clearInterval(this.auth_timer);
                  this.auth_timer = null;
                  this.time = 60;
                }
              }, 1000);
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    loginInOut3() {
      let data = {
        unionId: this.unionId
      };
      loginInOut3(data)
        .then(res => {
          console.log(res.data.code);
          if (res.data.code == "00000") {
            Cookies.set("token", res.data.data.token);
            Cookies.set("userId", res.data.data.userId);
            console.log(res.data.data.token);
            this.$message({
              message: "登录成功",
              type: "success"
            });
            if (res.data.data.accountType == "1") {
              this.$router.replace("/CIndex/company-home"); //公司登录
            } else if (res.data.data.accountType == "2") {
              this.$router.replace("/HIndex/hostipal-home");
            } else {
              this.$router.push("/person-home");
            }
          } else {
            this.$router.replace("/Bind");
            this.$message.success(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.Refresh();
          let data = {
            mobile: this.ruleForm2.mobile,
            code: this.ruleForm2.code,
            unionId: this.unionId
            // unionId: "ook-owtQWNVTZLnOVce6UC67vwn4"
          };
          console.log(data);
          wxbindMobile(data)
            .then(res => {
              if (res.data.code == "00000") {
                this.$message({
                  message: "绑定成功",
                  type: "success"
                });
                this.loginInOut3();
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  mounted() {
    this.unionId = Cookies.get("unionId");
    // this.unionId = "ook-owlRvl2RniSoFBQHG0WWgksg";

    // this.ruleForm2.mobile = 18716029800;
    // this.validMobile();
  }
};
</script>

<style>
</style>

<style scoped>
.bindphone {
  width: 420px;
  margin: 0 auto;
}
.tips {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(128, 128, 128, 1);
  line-height: 24px;
  margin-top: 20px;
  margin-bottom: 50px;
}
.img_code_input {
  width: 165px;
}
.img_code_img {
  display: inline-block;
  vertical-align: middle;
  margin-left: 15px;
}
.sub-btn {
  width: 400px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #0377d9;
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}
.title {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(2, 104, 191, 1);
  padding-top: 60px;
}
.bindsuccess img {
  display: inline-block;
}
.bindsuccess {
  text-align: center;
}
.succes_title {
  color: #0377d9;
  margin-bottom: 26px;
  margin-top: 16px;
}
.success_login {
  color: rgba(102, 102, 102, 1);
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/bindphone.vue